import { render, staticRenderFns } from "./project-data.vue?vue&type=template&id=524bc2dc&scoped=true"
import script from "./project-data.vue?vue&type=script&setup=true&lang=js"
export * from "./project-data.vue?vue&type=script&setup=true&lang=js"
import style0 from "@ui-common/vue-textarea/dist/vue-textarea.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "@ui-common/vue-file-upload/dist/vue-file-upload.css?vue&type=style&index=1&prod&lang=css&external"
import style2 from "@ui-common/vue-error-message/dist/vue-error-message.css?vue&type=style&index=2&prod&lang=css&external"
import style3 from "./project-data.vue?vue&type=style&index=3&id=524bc2dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524bc2dc",
  null
  
)

export default component.exports